import { ProjectCategories } from 'components/Dialog/types';

export const isNeutralServiceBreakCategory = (
  category?: ProjectCategories | string | null,
) =>
  category === ProjectCategories.plannedServiceBreak ||
  category === ProjectCategories.unplannedServiceBreak;

export const isTimeOffProjectCategory = (
  category?: ProjectCategories | string | null,
) =>
  category === ProjectCategories.medicalLeave ||
  category === ProjectCategories.vacations ||
  category === ProjectCategories.dayOff ||
  isNeutralServiceBreakCategory(category);

// B2B and civil-contract consultants have one absence category, "Service
// break" (PLANNED_SERVICE_BREAK); a day without work stays empty. Their legacy
// DAY_OFF and UNPLANNED_SERVICE_BREAK projects are no longer offered, but saved
// entries on them still display under the project name. Employment contracts
// keep their own categories (DAY_OFF is unpaid leave there).
export const isContractorContract = (contractType?: string | null) =>
  Boolean(contractType) && contractType !== 'EMPLOYMENT_CONTRACT';

export const isRetiredContractorAbsence = (
  category?: ProjectCategories | string | null,
  contractType?: string | null,
) =>
  isContractorContract(contractType) &&
  (category === ProjectCategories.dayOff ||
    category === ProjectCategories.unplannedServiceBreak);

export const SERVICE_BREAK_LABEL = 'SUMMARY.SERVICE_BREAK';

// Translation key naming the service-break project for a B2B or civil
// contract; undefined for other categories and for employment contracts.
export const getContractorAbsenceLabel = (
  category?: ProjectCategories | string | null,
  contractType?: string | null,
) =>
  isContractorContract(contractType) &&
  category === ProjectCategories.plannedServiceBreak
    ? SERVICE_BREAK_LABEL
    : undefined;
